import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      :host {\n        display: inline-block;\n        position: relative;\n        width: 400px;\n        height: 42px;\n        font-family: sans-serif;\n      }\n      .labelContainer {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .progressLabel {\n        color: var(--wired-progress-label-color, #000);\n        font-size: var(--wired-progress-font-size, 14px);\n        background: var(--wired-progress-label-background, rgba(255,255,255,0.9));\n        padding: 2px 6px;\n        border-radius: 4px;\n        letter-spacing: 1.25px;\n      }\n      path.progbox {\n        stroke: var(--wired-progress-color, rgba(0, 0, 200, 0.8));\n        stroke-width: 2.75;\n        fill: none;\n      }\n      .overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        pointer-events: none;\n      }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <div id=\"overlay\" class=\"overlay\">\n      <svg></svg>\n    </div>\n    <div class=\"overlay labelContainer\">\n      <div class=\"progressLabel\">", "</div>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS } from 'wired-lib/lib/wired-base';
import { customElement, property, css, html } from 'lit-element';
import { rectangle, hachureFill } from 'wired-lib';

var WiredProgress = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredProgress, _WiredBase);

  var _super = _createSuper(WiredProgress);

  function WiredProgress() {
    var _this;

    _classCallCheck(this, WiredProgress);

    _this = _super.apply(this, arguments);
    _this.value = 0;
    _this.min = 0;
    _this.max = 100;
    _this.percentage = false;
    return _this;
  }

  _createClass(WiredProgress, [{
    key: "render",
    value: function render() {
      return html(_templateObject(), this.getProgressLabel());
    }
  }, {
    key: "getProgressLabel",
    value: function getProgressLabel() {
      if (this.percentage) {
        if (this.max === this.min) {
          return '%';
        } else {
          var pct = Math.floor((this.value - this.min) / (this.max - this.min) * 100);
          return pct + '%';
        }
      } else {
        return '' + this.value;
      }
    }
  }, {
    key: "wiredRender",
    value: function wiredRender() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _get(_getPrototypeOf(WiredProgress.prototype), "wiredRender", this).call(this, force);

      this.refreshProgressFill();
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      var s = this.getBoundingClientRect();
      return [s.width, s.height];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      rectangle(svg, 2, 2, size[0] - 2, size[1] - 2, this.seed);
    }
  }, {
    key: "refreshProgressFill",
    value: function refreshProgressFill() {
      if (this.progBox) {
        if (this.progBox.parentElement) {
          this.progBox.parentElement.removeChild(this.progBox);
        }

        this.progBox = undefined;
      }

      if (this.svg) {
        var pct = 0;
        var s = this.getBoundingClientRect();

        if (this.max > this.min) {
          pct = (this.value - this.min) / (this.max - this.min);
          var progWidth = s.width * Math.max(0, Math.min(pct, 100));
          this.progBox = hachureFill([[0, 0], [progWidth, 0], [progWidth, s.height], [0, s.height]], this.seed);
          this.svg.appendChild(this.progBox);
          this.progBox.classList.add('progbox');
        }
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredProgress;
}(WiredBase);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredProgress.prototype, "value", void 0);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredProgress.prototype, "min", void 0);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredProgress.prototype, "max", void 0);

__decorate([property({
  type: Boolean
}), __metadata("design:type", Object)], WiredProgress.prototype, "percentage", void 0);

WiredProgress = __decorate([customElement('wired-progress')], WiredProgress);
export { WiredProgress };